import * as React from "react";
import GeneralModal from "./GeneralModal";
import { Grid, InputLabel, MenuItem, TextField } from "@mui/material";
import { snakeCaseToTitleCase } from "../utils/CaseFormatHelper";
import CustomDatePicker from "../common/CustomDatePicker";
import moment from "moment";
import { AuthenticationContext } from "../Context";
import { getHeaders } from "../utils/HeaderHelper";
import { useParams, useHistory } from "react-router-dom";

interface Props {
  modalOpen: boolean;
  setModalOpen: any;
  preSetEncounterType?: any;
  patientId?: string;
}

const NewEncounter: React.FC<Props> = (props: any) => {
  const history = useHistory();
  const [encounteTypeOptions, setEncounterTypeOptions] = React.useState<any>(
    {}
  );
  const authenticationSetting = React.useContext(AuthenticationContext);
  const [dateOfEncounter, setDateOfEncounter] = React.useState<any>(
    moment()
  );
  const [encounterType, setEncounterType] =
    React.useState<string>("med_administration");

  const encounterTypes = Object.entries(encounteTypeOptions).map((type) => {
    return (
      <MenuItem key={type[0]} value={type[0]}>
        {
          type[0] === "diabetes_management" ?
            "NDPERS Diabetes Program" :
            snakeCaseToTitleCase(type[0])
        }
      </MenuItem>
    );
  });

  let { id: patientIdFromParams } = useParams<{ id: string }>();
  const patientId = patientIdFromParams ?? props.patientId;

  
  React.useEffect(() => {
    if(props.preSetEncounterType) {
      setEncounterType(props.preSetEncounterType);
    }
  }, [props.preSetEncounterType]);

  React.useEffect(() => {
    getAccess();
  }, []);

  const createEncounter = () => {
    history.push(
      `/patient_reports/${patientId}/patient_encounters/new?encounter_type=${encounterType}&day_of_encounter=${dateOfEncounter.format('YYYY-MM-DD')}`
    );
  };

  const getAccess = () => {
    let url = `/encounters/new?patient_id=${patientId}`;

    fetch(url, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          console.log(result.error);
        } else {
          setEncounterTypeOptions(result?.resource?.encounter_types);
          setEncounterType(
            props.preSetEncounterType || result?.resource?.encounter_types?.med_administration
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <GeneralModal
      open={props.modalOpen}
      title="Create New Encounter"
      successCallback={createEncounter}
      closeCallback={() => props.setModalOpen(false)}
      width="430px"
      confirmButtonText="Create Encounter"
    >
      <Grid container spacing={1} className="encounter-modal">
        <Grid item xs={12} style={{ paddingLeft: 0 }}>
          <InputLabel
            htmlFor="encounter_type"
            sx={{ color: "#4A4442", marginBottom: "0" }}
          >
            Encounter Type
          </InputLabel>
        </Grid>
        <Grid item xs={12} style={{ marginBottom: "16px", paddingLeft: 0, paddingTop: 0 }}>
          <TextField
            id="encounter_type"
            size="small"
            value={props.preSetEncounterType || encounterType}
            required
            variant="outlined"
            onChange={(event) => setEncounterType(event.target.value)}
            select
            disabled={props.preSetEncounterType ? true : false}
            sx={{
              width: "100%",
              backgroundColor: "#efe9e7",
              borderRadius: "5px",
              "& fieldset": {
                border: "none",
                outline: "none",
              },
            }}
          >
            {encounterTypes}
          </TextField>
        </Grid>
        <CustomDatePicker
          id={"day_of_encounter"}
          label={"Date of Encounter"}
          placeholder={"Select Date of Encounter"}
          date={dateOfEncounter}
          handleDateChange={(date) => setDateOfEncounter(date)}
          disabled={false}
        />
      </Grid>
    </GeneralModal>
  );
};

export default NewEncounter;
